import { useContext } from "react";
import { ConsultancySignUpContext } from "./ConsultancySignUpContextProvider";

const useConsultancySignUpContext = () => useContext(ConsultancySignUpContext);

export default useConsultancySignUpContext;
